import { useEffect, useState } from 'react'
import { Modal } from 'components'
import ErrorMessage from 'components/forms/error-message'
import { lang } from 'config'
import _ from 'lodash'
import { Plus } from 'components/icons/outline'
import axios from 'axios'
import { toast } from 'react-hot-toast'
import nProgress from 'nprogress'
import Label from 'components/forms/label'
import SelectDescription from 'components/forms/select-description'
import useProductUnitRepositories from 'repositories/product-unit'
import Input from 'components/forms/input'

const Content = ({ data, onSubmit }) => {
    const { data: productUnitSelection, isLoading: isLoadingProductUnitSelection } = useProductUnitRepositories({
        paginate: false
    })

    const [productUnit, setProductUnit] = useState()
    const [productUnitId, setProductUnitId] = useState()
    const [sales, setSales] = useState()

    const [errors, setErrors] = useState({})

    useEffect(() => {
        if (productUnitId && !isLoadingProductUnitSelection) {
            setProductUnit(productUnitSelection?.find((row) => row.id === productUnitId))
        }
    }, [productUnitId, isLoadingProductUnitSelection])

    const handleSubmit = (e) => {
        e.preventDefault()

        if (!nProgress.isStarted()) {
            nProgress.start()

            toast.loading("Memuat", {
                id: "submit"
            })

            axios.post(`${process.env.REACT_APP_INVENTORY_API_URL}/discount/validate`, {
                type: 'dependency',
                product_unit_id: productUnitId,
                sales_item_count: sales
            }).then((response) => {
                toast.success(response.data.message, {
                    id: "submit"
                })

                onSubmit({
                    product_unit: productUnit,
                    sales_item_count: sales
                })

                nProgress.done()
            }).catch((error) => {
                if (error.response.status === 422) {
                    setErrors(error.response.data.errors)
                }
                toast.error(error.response.data.message, {
                    id: "submit"
                })

                console.log(error.response)

                nProgress.done()
            })
        } else {
            toast.error("Aksi sebelumnya sedang dimuat")
        }
    }

    return (
        <div className="mt-8 space-y-8">
            <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                    <div className="col-span-2">
                        <Label htmlFor="product_unit" value="Unit Produk" />
                        <SelectDescription onChange={(value) => setProductUnitId(value)} selection={productUnitSelection} isLoading={isLoadingProductUnitSelection} value={productUnitId} keyValue={(value) => value.id} title={(value) => value.name} description={(value) => value.long_name} placeholder="Pilih Unit Produk" error={errors.product_unit_id} />
                        <ErrorMessage error={errors.product_unit_id} />
                    </div>

                    <div className="col-span-2 sm:col-span-1">
                        <Label htmlFor="sales" value="Jumlah Item Penjualan" />
                        <Input placeholder="0" type="number" onChange={(e) => setSales(e.target.value)} value={sales} id="sales" error={errors.sales_item_count} />
                        <ErrorMessage error={errors.sales_item_count} />
                    </div>
                </div>
            </div>
            <div className="text-xs">
                <button onClick={handleSubmit} className="items-center px-6 py-3 text-white transition bg-brand-800 rounded-xl active:hover:scale-90">
                    <span>{lang.save}</span>
                </button>
            </div>
        </div>
    )
}

const Add = ({ data, onSubmit }) => {
    const [isOpen, setIsOpen] = useState(false)

    const openModal = () => setIsOpen(true)
    const closeModal = () => setIsOpen(false)

    const handleSubmit = (data) => {
        onSubmit(data)

        closeModal()
    }

    return (
        <>
            <button type="button" onClick={openModal} className="inline-flex items-center px-4 py-3 space-x-2 transition border border-neutral-200 bg-neutral-50 rounded-xl active:hover:scale-90">
                <Plus className="w-4 h-4" stroke={1.5} />
                <span>{lang.create}</span>
            </button>
            <Modal isOpen={isOpen} onClose={closeModal} title={`${lang.create} ${lang.data}`} content={<Content data={data} onSubmit={handleSubmit} />} />
        </>
    )
}

export default Add